export default __webpack_public_path__ + "static/media/Energizing Shoulders.baf79dce.jpg";